import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  coefficient?: string
}

const Coefficient = ({ coefficient }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.coefficient')}
      description={coefficient}
    />
  )
}

export default Coefficient
